/**
 * Exportar a transcrição: um .txt legível, uma linha por turno, com o deslocamento da chamada e quem falou, e
 * os momentos marcados no fim. O mesmo texto serve para colar numa nota ou anexar a um processo.
 */
import { groupTurns, timeLabel } from './transcriptProtocol';

const YOU = 'Você';

/**
 * @param {{
 *   title?: string, origin: number|null, segments: import('./transcriptProtocol').Segment[],
 *   moments: Array<{ id: string, at: number }>, localIdentity?: string|null, generatedAt?: Date,
 * }} input
 */
export function buildTranscriptText({ title, origin, segments, moments, localIdentity = null, generatedAt = new Date() }) {
    const lines = [];
    lines.push(`Transcrição${title ? `: ${title}` : ''}`);
    const zone = { timeZone: 'America/Sao_Paulo' };
    const day = generatedAt.toLocaleDateString('pt-BR', zone);
    const time = generatedAt.toLocaleTimeString('pt-BR', { ...zone, hour: '2-digit', minute: '2-digit' });
    lines.push(`Gerada em ${day} às ${time}`);
    lines.push('Idioma: Português (Brasil)');
    lines.push('');
    for (const turn of groupTurns(segments)) {
        const who = turn.identity === localIdentity ? YOU : turn.name;
        lines.push(`[${timeLabel(turn.startedAt, origin)}] ${who}: ${turn.text}`);
    }
    if (moments.length > 0) {
        lines.push('');
        lines.push('Momentos marcados:');
        for (const moment of [...moments].sort((a, b) => a.at - b.at)) lines.push(`- ${timeLabel(moment.at, origin)}`);
    }
    return `${lines.join('\n')}\n`;
}

/** Nome do arquivo: sem caracteres que o sistema de arquivos recusa, com a data. */
export function transcriptFilename(title, now = new Date()) {
    const base = String(title || 'chamada')
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-+|-+$/g, '').toLowerCase().slice(0, 60) || 'chamada';
    const day = now.toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo' });
    return `transcricao-${base}-${day}.txt`;
}

/** Baixa o texto como arquivo, no documento do botão clicado (a sala pode estar noutra janela). */
export function downloadText(filename, text, doc = document) {
    const url = URL.createObjectURL(new Blob([text], { type: 'text/plain;charset=utf-8' }));
    const link = doc.createElement('a');
    link.href = url;
    link.download = filename;
    doc.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 0);
}
